var app = angular.module('leonardo');

var FilterService = function ($q, $filter, $rootScope, PortfolioService, PropertyService, AccountService, AccountUserService, PropertyGroupService, CacheService) {
  var service = {};

  service.initialized = false;
  service.loading = false;
  service.filters = {};
  service.accounts = [];
  service.managers = [];
  service.groups = [];
  service.portfolios = [];
  service.properties = [];
  service.currentProperty = null;
  service.currentPortfolio = null;
  service.allSubFieldsGroup = [];

  service.getPropertyName = function () {
    if (service.hasFilter('property') && !service.currentProperty) {
      if (!service.loading) {
        service.loading = true;
        PropertyService.get(service.getFilter('property')).then(function (property) {
          service.currentProperty = property;
          service.loading = false;
        });
      }
    }
    if (service.currentProperty || service.hasFilter('property')) {
      return service.currentProperty ? service.currentProperty.name : '';
    }
    if (service.hasFilter('portfolio') && !service.currentPortfolio) {
      if (!service.loading) {
        service.loading = true;
        PortfolioService.get(service.getFilter('portfolio')).then(function (portfolio) {
          service.currentPortfolio = portfolio;
          service.loading = false;
        });
      }
    }
    if (service.currentPortfolio || service.hasFilter('portfolio')) {
      return service.currentPortfolio ? service.currentPortfolio.name : '';
    }
    return 'All portfolios';
  };

  service.getLabelProperty = function () {
    if (service.hasFilter('property')) {
      return 'Property - ' + service.getPropertyName();
    } else if (service.hasFilter('portfolio')) {
      return 'Portfolio - ' + service.getPropertyName();
    } else {
      return service.getPropertyName();
    }
  };

  service.setFilter = function (key, value, silently) {
    if (!isEmpty(value)) {
      service.filters[key] = value;
      if (!silently) {
        $rootScope.$broadcast('filter-service:filter-changed', key, value);
      }
    } else {
      service.removeFilter(key, silently);
    }
  };

  service.hasFilter = function (key, findEmpty) {
    if (findEmpty) {
      var filters_active = service.filters['filters'];
      if (filters_active && key !== 'filters') {
        if (!angular.isArray(filters_active)) {
          filters_active = filters_active.split(',');
        }
        return !isNull(filters_active) ? _.contains(filters_active, key) : false;
      }
    } else {
      return key in service.filters && !isNull(service.filters[key]);
    }
  };

  service.resetFilters = function (silently) {
    angular.forEach(service.filters, function (value, key) {
      service.removeFilter(key, true);
    });
    if (silently) {
      return;
    }
    $rootScope.$broadcast('filter-service:filters-reset');
    window.oldReduxStore.dispatch(window.oldReduxActions.resetFilters());
  };

  service.clearFilters = function (silenty, exceptions, filters_name) {
    var filters_exceptions = angular.isArray(exceptions)
      ? exceptions.concat(['account', 'portfolio', 'property'])
      : ['account', 'portfolio', 'property'];
    if (filters_name && !isNull(service.filters[filters_name])) {
      var filters_active = angular.isArray(service.filters[filters_name])
        ? service.filters[filters_name]
        : service.filters[filters_name].split(',');
      filters_active.push(filters_name);
      angular.forEach(filters_active, function (value) {
        if (!filters_exceptions.includes(value)) {
          service.removeFilter(value, silenty);
        }
      });
    } else {
      angular.forEach(service.filters, function (value, key) {
        if (!filters_exceptions.includes(key)) {
          service.removeFilter(key, silenty);
        }
      });
    }
  };

  service.getFilter = function (key, findEmpty) {
    if (findEmpty) {
      var filters_active = service.filters['filters'];
      if (filters_active && key !== 'filters') {
        if (!angular.isArray(filters_active)) {
          filters_active = filters_active.split(',');
        }
        if (_.contains(filters_active, key)) {
          return (!isNull(service.filters[key]) ? service.filters[key] : '!null');
        }
        return service.filters[key];
      } else {
        return service.filters[key];
      }
    } else {
      return service.filters[key];
    }
  };

  service.removeFilter = function (key, silently) {
    if (!isNull(service.filters[key])) {
      delete service.filters[key];
      switch (key) {
        case 'portfolio':
          service.currentPortfolio = null;
          break;
        case 'property':
          service.currentProperty = null;
          break;
      }
      if (!silently) {
        $rootScope.$broadcast('filter-service:filter-removed', key);
      }
    }
  };

  service.getPropertyByAccount = function () {
    var defer = $q.defer();
    if (AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.account) {
      let filteredProperties = $filter('filter')(service.properties, {
        account: AccountUserService.currentAccountUser.account.id
      });
      if (filteredProperties && filteredProperties.length > 0) {
        // Resolve the first property, sorted by name
        defer.resolve($filter('orderBy')(filteredProperties, 'name')[0]);
      } else {
        defer.resolve(service.properties.length > 0 ? service.properties[0] : null);
      }
    } else {
      defer.resolve(null);
    }
    return defer.promise;
  };

  service.setProperty = function (property) {
    var defer = $q.defer();
    if (property) {
      var property_id = property.id ? property.id : property;
      if (!service.currentProperty || service.currentProperty.id != property_id) {
        PropertyService.get(property.id ? property.id : property).then(
          function (result) {
            var account_id = result.account && result.account.id ? result.account.id : result.account;
            var portfolio_id = result.portfolio && result.portfolio.id ? result.portfolio.id : result.portfolio;
            service.currentProperty = result;
            PortfolioService.get(portfolio_id).then(function (portfolio) {
              service.currentPortfolio = portfolio;
            });
            service.setFilter('account', account_id);
            service.setFilter('portfolio', portfolio_id);
            service.setFilter('property', result.id);
            defer.resolve();
          },
          function () {
            defer.resolve();
          }
        );
      } else {
        defer.resolve();
      }
    } else {
      defer.resolve();
    }
    return defer.promise;
  };

  service.initManagers = function (authData, account_id) {
    service.managers = [];
    if (authData.account) {
      service.managers.push({
        id: authData.account.id,
        name: authData.account.name
      });
    }
    if (account_id) {
      angular.forEach(authData.accountsManager, function (account) {
        if (account.id == account_id) {
          angular.forEach(account.managed_to_me, function (value) {
            service.managers.push(value);
          });
        }
      });
    } else {
      if (authData.account) {
        angular.forEach(authData.account.managed_to_me, function (value) {
          service.managers.push(value);
        });
      }
    }
  };

  service.init = function (accounts, fromInit) {
    service.accounts = [];
    service.groups = [];
    service.portfolios = [];
    service.properties = [];
    service.currentProperty = null;
    service.currentPortfolio = null;

    var promisesInit = [];
    var defer = $q.defer();

    // If accounts are passed, set them directly
    if (accounts) {
      service.accounts = accounts;
    } else if (!fromInit) {
      // If not initializing from AuthDataService, fetch accounts
      CacheService.getOrFetch('accounts', function() {
        return AccountService.getAll({ essential: true, not_empty: true });
      }).then(function (data) {
        service.accounts = data.results ? data.results : data;
      });
    }

    CacheService.getOrFetch('groups', function() {
      return PropertyGroupService.getAll({ essential: true, not_empty: true });
    }).then(function (data) {
      service.groups = data.results ? data.results : data;
    });

    promisesInit.push(
      CacheService.getOrFetch('portfolios', function() {
        return PortfolioService.getAll({ not_empty: true });
      }).then(function (data) {
        service.portfolios = data.results ? data.results : data;
      })
    );

    promisesInit.push(
      CacheService.getOrFetch('properties', function() {
        return PropertyService.getAll({ not_empty: true, essential: true }, false, true);
      }).then(function (data) {
        service.properties = data.results ? data.results : data;
      })
    );

    // When all promises are resolved
    $q.all(promisesInit).then(
      function () {
        // Only execute this if `fromInit` is false (not initialized by AuthDataService)
        if (!fromInit) {
          service.getSetProperty(null, defer);
        } else {
          // If fromInit is true, just resolve the deferred promise without further action
          defer.resolve();
        }
      },
      function (error) {
        defer.reject(error);
      }
    );

    return defer.promise;
  };

  // new function for handling first property selection once we have accountUser

  service.getSetProperty = (results_accounts, promise) => {
    service.initialized = false;
    if(!promise){
      promise = $q.defer();
      createdPromise = true;
    }
    if (results_accounts) {
      service.accounts = results_accounts;
    }
    service.getPropertyByAccount().then(
      function (data) {
        $q.when(service.setProperty(data)).then(
          function () {
            $rootScope.$broadcast('filter-service:initiated');
            service.initialized = true;
            if (promise && typeof promise.resolve === 'function') {
              promise.resolve();
            }
          },
          function (error) {
            if (promise && typeof promise.reject === 'function') {
              promise.reject(error);
            }
          }
        );
      },
      function (error) {
        if (promise && typeof promise.reject === 'function') {
          promise.reject(error);
        }
      }
    );

    if (createdPromise) {
      return promise.promise;
    }
  }

  service.updateList = function (array, element, remove) {
    var index = -1;
    angular.forEach(service[array], function (value, key) {
      if (element.id === value.id) {
        index = key;
      }
    });
    if (index < 0 && !remove) {
      service[array].push(element);
    } else if (remove) {
      service[array].splice(index, 1);
    } else {
      service[array][index] = element;
    }
    service[array] = $filter('orderBy')(service[array], 'name');
  };

  service.resetProperty = function () {
    if (service.properties.length > 0) {
      service.setProperty(service.properties[0]);
    } else {
      service.removeFilter('property');
      service.removeFilter('portfolio');
    }
  };

  service.resetPortfolios = function () {
    PortfolioService.getAll({ not_empty: true, essential: true }).then(function (data) {
      service.portfolios = data.results ? data.results : data;
      service.resetProperties();
    });
  };

  service.resetProperties = function () {
    PropertyService.getAll({ not_empty: true, essential: true }).then(function (data) {
      service.properties = data.results ? data.results : data;
      service.resetProperty();
    });
  };

  service.showFilters = function(filters_to_add) {
    var filters = service.hasFilter('filters') ? service.getFilter('filters') : [];
    if (!angular.isArray(filters)) {
      filters = filters.split(',');
    }
    filters_to_add.forEach(function(f){
      if (!_.contains(filters, f)) {
        filters.push(f);
      }
    });
    service.setFilter('filters', filters, true);
  };
  
  service.clearData = function () {
    service.initialized = false;
    service.loading = false;
    service.filters = {};
    service.accounts = [];
    service.managers = [];
    service.groups = [];
    service.portfolios = [];
    service.properties = [];
    service.currentProperty = null;
    service.currentPortfolio = null;
    service.allSubFieldsGroup = [];
  };

  $rootScope.$on('group:added', function ($event, group) {
    service.updateList('groups', group);
  });
  $rootScope.$on('group:deleted', function ($event, group) {
    service.updateList('groups', group, true);
  });
  $rootScope.$on('group:updated', function (event, group) {
    service.updateList('groups', group);
  });

  $rootScope.$on('portfolio:added', function ($event, portfolio) {
    service.updateList('portfolios', portfolio);
  });
  $rootScope.$on('portfolio:deleted', function ($event, portfolio) {
    service.updateList('portfolios', portfolio, true);
  });
  $rootScope.$on('portfolio:updated', function (event, portfolio) {
    if (service.currentPortfolio && service.currentPortfolio.id === portfolio.id) {
      service.currentPortfolio = portfolio;
    }
    service.updateList('portfolios', portfolio);
  });

  $rootScope.$on('property:added', function ($event, property) {
    service.updateList('properties', property);
  });
  $rootScope.$on('property:deleted', function ($event, property) {
    service.updateList('properties', property, true);
  });
  $rootScope.$on('property:updated', function (event, property) {
    if (service.currentProperty.id === property.id) {
      service.currentProperty = property;
    }
    service.updateList('properties', property);
  });

  return service;
};

app.factory('FilterService', [
  '$q',
  '$filter',
  '$rootScope',
  'PortfolioService',
  'PropertyService',
  'AccountService',
  'AccountUserService',
  'PropertyGroupService',
  'CacheService',
  FilterService
]);
